import {twentyfiveColor} from '../../helpers/general'


const tw_GMT_time_gap = 8*60*60*1000
// 頁數計算(20)
export function pageFomat(authors){
    const allauthor = authors
    const totalPage = Math.ceil(authors.length/20)
    const pageContain = []
    let s = 0
    let e =20
    
    for(let i=0;i<totalPage;i++){
      let thisPage=[]
      for(let j=s;j<e;j++){
        if(j<authors.length){
          thisPage.push(allauthor[j])
        }
      }
      pageContain.push(thisPage)
      s+=20;
      e+=20;
    }

    return pageContain
}
// for YoutuberDetail
export function seriesMaker(type,data) {
  let series = data.map(item=>{
    return [timestampConverter(item.last_time),item[type]]
  })
  return series
}
// value 找 key
export function findKey (obj,value, compare = (a, b) => a === b) {
  return Object.keys(obj).find(k => compare(obj[k], value))
}
// 日期 formate
export function dateApiFormate(date){
  return date.substring(0,4)+date.substring(5,7)+date.substring(8,10)
}
// timestamp convert
export function timestampConverter(date) {
  let datetime = new Date(Number(date.substring(0,4)),Number(date.substring(4,6))-1,Number(date.substring(6,8))).getTime()+tw_GMT_time_gap
  return datetime
}
export function otherTimestampConvert(date) {
  let datetime = new Date(Number(date.substring(0,4)),Number(date.substring(5,7))-1,Number(date.substring(8,10)),Number(date.substring(11,13)),Number(date.substring(14,16))).getTime()+tw_GMT_time_gap
  return datetime
}
export function timestampTOstringDate(date){
  let year = new Date(date).getFullYear()
  let month = new Date(date).getMonth()+1 > 9 ? new Date(date).getMonth()+1 : '0' + (new Date(date).getMonth()+1)
  let day = new Date(date).getDate() > 9 ? new Date(date).getDate() : '0' + (new Date(date).getDate()+1)
  return year+'-'+month+'-'+day
}
// 移除重複
export function removeDuplicates(array, props) {
  let newArray = [];
  let lookupObject  = {};

  for(var i in array) {
     lookupObject[array[i][props]] = array[i];
  }

  for(i in lookupObject) {
      newArray.push(lookupObject[i]);
  }
   return newArray;
}
// 計算同一個 props 下 target 的總和
export function sumValueByProps(array,target,props) {
  let sumDict = {}
  const nonRepeatProps = array.map(item => item[props])
  .filter(function(item, index, arr){return arr.indexOf(item) === index})

  nonRepeatProps.forEach(item=>{
      sumDict[item]=0
  })

  array.forEach(item=>{
      if(sumDict[item[props]] !== undefined){
          sumDict[item[props]] = sumDict[item[props]] + Number(item[target])
      }
  })
  return sumDict
}
// 數字 formate
export function carryNumber(num,shorter=true) {
  let number = parseInt(num)
  if(number > 9999){
    let ten_thousandth = Math.floor(number / 10000)
    if(ten_thousandth> 9999){
        let hundred_millionths = Math.floor(number / 100000000)
        ten_thousandth = ten_thousandth % 10000
        const short = hundred_millionths+'億'
        const full = hundred_millionths+'億'+ten_thousandth+'萬'
        
        return shorter ? short : full
    }
    let remainder = number % 10000 === 0 ? '' :  number % 10000
    const short = ten_thousandth+'萬'
    const full = ten_thousandth+'萬'+ remainder
    return shorter ? short : full 
  }
  return number
}
// 數字 formate
export function numberWithCommas(x,isShort=false) {
  if(isShort) return carryNumber(x)
  // 大神版正則表達
  // 1
  // return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  // 2
  // var numStr = (x || 0).toString();
  // return numStr.replace(/(\d)(?=(?:\d{3})+$)/g, '$1,');
  
  // 原版
  return x.toLocaleString()
}
// for topochart
export function buildNodeAndRealtion(data){
  // waring 
  // 這個 function 又臭又長
  // 如果你是想了解這個 function 在幹嘛 看這裡就好 我不想要氣你 :)
  // 如果後端資料格式沒改的話基本上不會出問題 但如果還是有其他問題 還是建議看完這裡
  // ----
  // 最終結果是要產出 3 個資料 （按照 react-graph-vis 1.0.2 要求的格式
  // 1. nodeData : 全部的節點 以下簡稱 node
  // 2. edgeData : 節點與節點之間的連結 以下簡稱 edge
  // 3. nodeStyle : 圖表的顯示樣式 按照 group 設定
  //
  // 所以這個 function 做了幾件事
  // 1. 將 json.data 裡的資料排序 並取前 10 個留言最多的作者 => 為了避免畫面混亂
  // 2. 將留言者取出 把他們設定成 key node (中心點) 後面將以 author_id 當作分群的條件（group） 
  // 3. 將各留言者在同頻道的留言合併並計算留言數
  // 4. 設定每個 node 的資料格式 =================================> 得到 nodeData
  // 5. 設定誰從屬於誰 (node 屬於哪個 key node)，按照 author_id 分 => 得到 edgeData
  // 6. 設定每個 group 的 nodeStyle =============================> 得到 nodeStyle
  // ---end---


  // -------------- 列出 author_id 的列表 並只留下關聯最多的 10 個 author_id 和 data -----------
  const top10authorData = []
  //取出所有留言者
  let authorList = [...new Set(data.map(item =>{
      let object = {
          author_id : item.author_id,
          author_name : item.author_name,
          connectCount : 0
      }
      return JSON.stringify(object)
  }))].map(item => JSON.parse(item));

  //計算每個留言者跟其他頻道的連結數量
  data.forEach(item => {
    authorList.forEach((author,index)=>{
      if(item.author_id === author.author_id){
        authorList[index].connectCount += 1
      }
    })
  })

  // 取前十
  authorList = authorList.sort((a, b) => {
    let pre = a.connectCount
    let next =  b.connectCount
    return (pre < next) ? 1 : (pre > next) ? -1 : 0
  }).slice(0,10)

  //將與前十有關聯的資料放入 top10authorData
  data.forEach(item=>{
    authorList.forEach(author=>{
      if(item.author_id === author.author_id){
        top10authorData.push(item)
      }
    })
  })
  // --------------------------------------------------------------------

  //創造拓墣圖中心節點（留言者）
  const keyNode = authorList.map((node,index)=>{
      return{
          group:node.author_id,
          label:node.author_name,
          uid:node.author_id,
          id:index,
          cid:0,
      }
  })

  // 合併各留言者在同頻道的留言 => 為了讓畫面看起來精簡
  const groupByAuthor = authorList.map(a=>a.author_id).reduce((acc,curr)=>(acc[curr]=[],acc),{})
    const nonRepeatChannelData = []

    top10authorData.forEach(item=>{
        groupByAuthor[item.author_id].push(item)
    })

    authorList.forEach(a=>{
      let channelCount = groupByAuthor[a.author_id].map(node=>node.channel_title).reduce((acc,curr)=>(acc[curr]=0,acc),{})
      const data = groupByAuthor[a.author_id].filter((scape, index, arr) => {
          return arr.findIndex(s =>{
              if(scape.channel_title === s.channel_title) channelCount[scape.channel_title] +=1 // 計算重複數目

              return scape.channel_title === s.channel_title
          }) === index;
      })
      
      // 這裡算是錯誤地採用 call by reference 還成功
      // 簡單來說就是把上面計算的重複數量加入處理完的資料中當成 count 屬性 
      data.map(media=>{
          media['count']=channelCount[media.channel_title]
      })

      nonRepeatChannelData.push(...data) 
  })

  // 格式化每個節點
  const conceptNode = nonRepeatChannelData.map((item, index) => {
    return({
        group:item.author_id,
        cid: 0,
        id: index + authorList.length,
        label: item.channel_title,
        title: `<div class="topology-node-title">
                    <div class="channel">影片： ${item.video_title}</div>
                    <div class="describe">回文者： ${item.author_name}</div>
                    <div class="describe">留言數： ${item.count}</div>
                </div>`,
        uid: item.author_id,
        author: item.author_name,
        video_id:item.video_id,
        channel_id:item.channel_id,
        channel_name:item.channel_title
    });
  })

  //將留言者合併進 node
  conceptNode.unshift(...keyNode)

  // 連接點跟點之間
  const edgesData = conceptNode.map((node, index) => {
      let edges ={}
      keyNode.forEach(author=>{
          if(node.group === author.group){
              edges['from'] = author.id
              edges['to'] = node.id
          }
      })
      return edges
  }).filter(item=>item.from !== item.to );

  // add nodeStyle
  const nodeStyle = {}
  keyNode.forEach((node,index)=>{
    let color =randomColor()
    nodeStyle[node.group]={
      // color: { background: `#${twentyfiveColor[index]}`},
      color: {background: color},
      shape: 'dot',
      size: 10,
      font: {size: 12,color: '#5c6873'}
    }
  })

  return {nodeData:conceptNode,edgeData:edgesData,nodeStyle:nodeStyle}
}

export function randomColor() {
  const red = Math.floor(Math.random() * 256).toString(16).padStart(2, '0');
  const green = Math.floor(Math.random() * 256).toString(16).padStart(2, '0');
  const blue = Math.floor(Math.random() * 256).toString(16).padStart(2, '0');
  return `#${red}${green}${blue}`;
}
// for master-detail 
export function findThePoint(series,type){
  try {
    if(series[0].name){
      if(type === 'end'){
        let latestNum = 0
        series.forEach((item,index)=>{
          if(item.data.length>series[latestNum].data.length){
            latestNum = parseInt(index)
          }
        })
        return series[latestNum].data[series[latestNum].data.length - 1].x
      }
      return series[0].data[0].x
    }else{
      if(type === 'end') return series[series.length - 1][0]
      else return series[0][0]
    }
  } catch (error) {
    console.log(error)
    return null
  }
}

export function gatherData(datas){
  let fun = (acc,curr)=>(acc[curr]=[],acc)
  let days = [ ...new Set(datas.map(day=>day.ymd))]
  let groupByDay = days.reduce(fun,{})
  let gatherData =[]

  datas.forEach(data=>{
      groupByDay[data.ymd].push(data) 
  })
  
  Object.values(groupByDay).forEach(day=> gatherData.push(...combineHoursData(day)))

  return gatherData
}

function combineHoursData(Day){
  let end = 3
  let start = 0
  let dayData = []

  for(let i = 0 ; i < 6 ;i++){
      let stage = []
      let obj = {}
      Day.forEach(hour=>{
          let time = parseInt(hour.doh)
          if( start <= time && time <= end){
              stage.push(hour)
          }
      })
      if(stage.length>0){
          let max =Math.max(...stage.map(day=>day.count))

          obj=stage[0]
          obj.doh = stage.find(day=>day.count === max ).doh
          obj.count = stage.reduce((acc,curr)=>(acc+=curr.count,acc),0)
          dayData.push(obj)
      }
      end += 4
      start += 4
  }
  return dayData
}


// WEBPACK FOOTER //
// ./src/components/channelSearch/channelHelper.js